import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EMPTY, Observable, catchError, filter } from 'rxjs';

import { Page, PageService, ServerResponseService } from '@speedy/core';

@Injectable({ providedIn: 'root' })
export class PageResolver {
  private readonly pageService = inject(PageService);
  private readonly serverResponseService = inject(ServerResponseService);

  resolve(route: ActivatedRouteSnapshot): Observable<Page> {
    const identifier = route.params?.identifier;

    return this.pageService.getPage(identifier).pipe(
      filter((page) => {
        if (!page) {
          this.serverResponseService.setNotFound();
          return false;
        }
        return true;
      }),
      catchError(() => {
        this.serverResponseService.setNotFound();
        return EMPTY;
      }),
    );
  }
}
